import { Injectable } from '@angular/core';
import { ApiMedia } from './api/api-media.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private apiMedia: ApiMedia) {}

  async fetchFile(uuid: string): Promise<string> {
    const blob = await firstValueFrom(this.apiMedia.viewMedia(uuid));

    return URL.createObjectURL(blob);
  }

  async fetchFileOrFallback(
    uuid: string | null | undefined,
    fallback: string = 'assets/images/extensions/undefined-icon.svg'
  ): Promise<string> {
    if (!uuid) {
      return fallback;
    }

    try {
      return await this.fetchFile(uuid);
    } catch (error) {
      console.error('Error fetching file:', error);
      return fallback;
    }
  }

  viewFile(uuid: string): void {
    this.apiMedia.viewMedia(uuid).subscribe({
      next: (blob: Blob) => {
        this.view(blob);
      },
      error: (error) => {
        console.error('Error viewing file:', error);
      },
    });
  }

  downloadFile(uuid: string, fileName: string): void {
    this.apiMedia.viewMedia(uuid).subscribe({
      next: (blob: Blob) => {
        this.download(blob, fileName);
      },
      error: (error) => {
        console.error('Error downloading file:', error);
      },
    });
  }

  view(blob: Blob): void {
    try {
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');

      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 1000);
    } catch (error) {
      console.error('Error viewing file:', error);
    }
  }

  download(blob: Blob, fileName: string): void {
    try {
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }
}
